// extracted by mini-css-extract-plugin
module.exports = {"header__notification":"HeaderNotification_header__notification__2RFG7","header__notification_text":"HeaderNotification_header__notification_text__VRFvd"};